import { get, handleResult, post, postStream } from '@/util';
import { Message } from './components/ChatContainer';
import { isNotEmpty } from '@qsxy/element-plus-react';

export const doChat = (message: any, onProgress?: (val: string, conversation: Message['conversation']) => void) => {
	return new Promise<{ result: string; conversation: Message['conversation'] }>(resolve => {
		const onSuccess = (result: string, conversation: Message['conversation']) => {
			resolve({ result, conversation });
		};
		postStream('/rest/chat/chatMsg', message, onProgress, onSuccess);
	});
};

export const renameConversation = (params: { user: string; name: string; conversation_id: string }) => {
	return new Promise<{ result: string; conversation: Message['conversation'] }>((resolve, reject) => {
		post(
			'/rest/chat/renameConversation',
			{ ...params, auto_generate: false },
			result => handleResult(result, ({ data }) => (isNotEmpty(data) ? resolve(data) : reject), reject),
			reject,
		);
	});
};

export const renameLocalConversation = (params: { id: string; title: string }) => {
	return new Promise<{ result: string; conversation: Message['conversation'] }>((resolve, reject) => {
		post('/conversation/edit', { ...params, auto_generate: false }, result => handleResult(result, ({ data }) => (isNotEmpty(data) ? resolve(data) : reject), reject), reject);
	});
};

export const getSuggsted = (params: { user: string; message_id: string }) => {
	return new Promise<string[]>((resolve, reject) => {
		get('/rest/chat/getSuggsted', params, result => handleResult(result, ({ data }) => (isNotEmpty(data) ? resolve(data ?? []) : reject)), reject);
	});
};

export const countVisitorChat = (params: { id: string }) => {
	return new Promise<number>((resolve, reject) => {
		post(
			'/app/visitor/chatCount/save',
			{ ...params, baseURL: '/server' },
			result => handleResult(result, ({ data }) => (isNotEmpty(data) ? resolve(data ?? 0) : reject)),
			reject,
		);
	});
};

export const getVisitorChatCount = (params: { id: string }) => {
	return new Promise<number>((resolve, reject) => {
		post(
			'/app/visitor/chatCount/get',
			{ ...params, baseURL: '/server' },
			result => handleResult(result, ({ data }) => (isNotEmpty(data) ? resolve(data ?? 0) : reject)),
			reject,
		);
	});
};
